export default "__VITE_ASSET__81344956__"